import BaseModel from 'src/model/base.model';

class AddressModel extends BaseModel {
  public number: number = 0;
  public name: string = '';
  public addressLine1: string = '';
  public addressLine2: string = '';
  public addressLine3: string = '';
  public addressLine4: string = '';
  public postalCode: string = '';
  public country: string = '';
  public countryCode: string = '';
  public stateCode: string = '';
  public taxJurisdiction: string = '';
}

export default AddressModel;
